/**
 * Deterministic per-user presence color.
 *
 * Mirror of the Go implementation in
 * backend/services/zensei-api/webapi/liveblocks_auth_handler.go so that the
 * color returned by `resolveUsers` (consumed by `useUser`) matches the color
 * carried in the `userInfo` we set on the Liveblocks ID token (consumed by
 * `useOther().info`). Same palette, same FNV-1a 32-bit hash, same modulo.
 *
 * Keep the palette in sync with the backend.
 */

const PALETTE = [
  "#4263eb",
  "#7048e8",
  "#c92a2a",
  "#e67700",
  "#2b8a3e",
  "#1098ad",
  "#d6336c",
  "#5c7cfa",
  "#f76707",
  "#0ca678",
] as const;

const FNV_OFFSET_BASIS_32 = 0x811c9dc5;
const FNV_PRIME_32 = 16777619;

function fnv1a32(input: string): number {
  let hash = FNV_OFFSET_BASIS_32;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME_32) >>> 0;
  }
  return hash >>> 0;
}

/**
 * @param userId Stable user identifier (canonical UUID string in our backend).
 */
export function userPresenceColor(userId: string): string {
  return PALETTE[fnv1a32(userId) % PALETTE.length];
}
